import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, AlertCircle, Info, AlertTriangle, X } from 'lucide-react';
import { useUIStore } from '../../stores/uiStore';

const icons = {
  success: CheckCircle,
  error:   AlertCircle,
  info:    Info,
  warning: AlertTriangle,
};

const colors = {
  success: 'border-emerald-500/50 bg-emerald-900/50 text-emerald-200',
  error:   'border-red-500/50 bg-red-900/50 text-red-200',
  info:    'border-blue-500/50 bg-blue-900/50 text-blue-200',
  warning: 'border-amber-500/50 bg-amber-900/50 text-amber-200',
};

export const Toast: React.FC = () => {
  const { toast, hideToast } = useUIStore();

  return (
    <AnimatePresence>
      {toast?.visible && (
        <motion.div
          className="toast-region fixed left-1/2 z-[100] -translate-x-1/2 w-[calc(100vw-2rem)] max-w-sm"
          initial={{ y: 20, opacity: 0, scale: 0.95 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 20, opacity: 0, scale: 0.95 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        >
          <div role="status" aria-live="polite" className={`flex items-center gap-3 px-3 py-2.5 rounded-xl border backdrop-blur-sm shadow-dark-lg ${colors[toast.type]}`}>
            {React.createElement(icons[toast.type], { size: 18, className: 'shrink-0' })}
            <span className="text-sm font-medium flex-1">{toast.message}</span>
            <button type="button" onClick={hideToast} className="icon-control shrink-0 opacity-70 hover:opacity-100" aria-label="Close notification">
              <X size={14} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
